/**
 * Minimum WebView version required for the app to function properly
 * Version 89 is known to work correctly
 */
export const MINIMUM_WEBVIEW_VERSION = 89

function parseWebViewMajorVersion(
  versionString: string | undefined
): number | null {
  if (!versionString) {
    return null
  }

  // Extract the first part before any space or parenthesis
  const cleanVersion = versionString.split(/[\s(]/)[0]

  // Extract the major version
  const match = cleanVersion.match(/^(\d+)/)

  if (match && match[1]) {
    return parseInt(match[1], 10)
  }

  return null
}

/**
 * Checks if the WebView version meets the minimum requirement
 * @param versionString - Version string to check
 * @returns true if version is sufficient, false otherwise
 */
export function isWebViewVersionSufficient(
  versionString: string | undefined
): boolean {
  const majorVersion =
    parseWebViewMajorVersion(versionString)

  if (majorVersion === null) {
    // If can't parse, assume it's insufficient
    return false
  }

  return majorVersion >= MINIMUM_WEBVIEW_VERSION
}
